import React from "react";
import { Card, Typography, Tag } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import { cardStyle } from "../styles";

const { Text } = Typography;

const statItemStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "12px 16px",
  backgroundColor: "#F8FAFC",
  borderRadius: 6,
  marginBottom: 12,
};

export default function StatisticsCard({ customer }) {
  // const daysActive = customer.created_at
  //   ? Math.floor((new Date() - new Date(customer.created_at)) / (1000 * 60 * 60 * 24))
  //   : 0;

  return (
    <Card
      title={
        <>
          <ClockCircleOutlined style={{ marginRight: 8 }} />
          Thống kê
        </>
      }
      style={cardStyle}
    >
      {/* <div style={statItemStyle}>
        <Text>Thời gian hoạt động</Text>
        <Text strong>{daysActive} ngày</Text>
      </div> */}
      <div style={statItemStyle}>
        <Text>Trạng thái</Text>
        <Tag color={customer.status ? "success" : "error"}>
          {customer.status ? "Hoạt động" : "Ngừng hoạt động"}
        </Tag>
      </div>
    </Card>
  );
}